import React, { Component } from 'react';
import { matchPath } from 'react-router-dom';
import { Loading } from 'carbon-components-react';
import { toast } from 'react-toastify';
import { UnitsAndStores, Filters, SendDate, Message, Type } from '../../../../components/campaigns';
import { isCampaignFilterSelected } from '../../../../utils';
import { getByDmService, pathDmService, updateDmService } from '../../../../services/Api';
import campaignSteps from '../../../../fixtures/adminCampaignMessages.json';

class Detail extends Component {
  constructor(props) {
    super(props);
    const { data } = this.props;

    this.orderId = data.id;

    this.state = {
      isSaving: false,
      comments: [],
    };
  }

  componentWillMount = async () => {
    await this.loadCampaign();
  }

  loadCampaign = async () => {
    try {
      const data = await getByDmService('/Pedido/GetCampanhaMensagem', this.orderId);

      const showAdminMenuStoraged = localStorage.getItem('showAdminMenu');
      const canSave = ([4, 2, 3].indexOf(data.status.id) > -1 ? true : showAdminMenuStoraged !== 'false')
      this.setState({ data, canSave, isLoading: false });
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar as campanhas');
      this.setState({ data: null, isLoading: false });
    }
  };

  saveStep = async stepData => {
    const { data } = this.state;
    const orderId = data.id;
    const campaignItem = data.itensCampanhaMensagem[0];

    this.setState({ isSaving: true });

    const result = await updateDmService('/Pedido/EditaCampanhaMensagem', campaignItem.id, {
      Pedido: orderId,
      ...stepData,
    });
    this.setState({ isSaving: false });
    await this.loadCampaign();
    return result;
  };

  saveSendDate = async stepData => {
    const { match } = this.props;
    const newMatch = matchPath(match.url, {
      path: '/admin/comunicacao/campanha/:id/detalhe',
    });

    this.setState({ isSaving: true });

    const result = await pathDmService(`Pedido/AtualizaInformacoesDataEnvio/${newMatch.params.id}`, {
      DataEnvio: stepData.currentDate,
    });
    this.setState({ isSaving: false });
    await this.loadCampaign();
    return result;
  };

  renderComponent = step => {
    const { data } = this.state;
    const { comments, canSave } = this.state;
    const campaignItem = data.itensCampanhaMensagem[0];
    
    switch (step.form) {
      case 'smsPush':
        return (
          <div key={step.id}>
            <Type
              key={step.id}
              step={step}
              sms={data.sms}
              push={data.push}
              disabled={canSave === false}
              isAdmin
            />

          </div>
        );
      case 'dataEnvio':
        return (
          <div key={step.id}>
            <SendDate
              step={step}
              campaignItem={campaignItem}
              dates={campaignItem.datasEnvio}
              saveStep={this.saveSendDate}
              disabled={canSave === false}
              showSave={canSave}
              comments={comments}
              isAdmin
              singleDate
            />

          </div>
        );
      case 'unidades':
        return (
          <UnitsAndStores
            key={step.id}
            step={step}
            campaignItem={campaignItem}
            list={campaignItem.unidadesLojas}
            saveStep={this.saveStep}
            disabled={canSave === false}
            showSave={canSave}
            comments={comments}
            isAdmin
          />
        );
      case 'filtros':
        return (
          <Filters
            key={step.id}
            step={step}
            campaignItem={campaignItem}
            selectedValue={isCampaignFilterSelected(campaignItem)}
            saveStep={this.saveStep}
            disabled={canSave === false}
            showSave={canSave}
            comments={comments}
            isAdmin
          />
        );
      case 'mensagem':
        return (
          <Message
            key={step.id}
            step={step}
            campaignItem={campaignItem}
            selectedValue={campaignItem.mensagem}
            saveStep={this.saveStep}
            disabled={canSave === false}
            showSave={canSave}
            comments={comments}
            isAdmin
          />
        );
      case 'sac':
        return (
          <Message
            key={step.id}
            step={step}
            campaignItem={campaignItem}
            selectedValue={campaignItem.informacoesSAC}
            saveStep={this.saveStep}
            disabled={canSave === false}
            showSave={canSave}
            comments={comments}
            isAdmin
          />
        );
      default:
        return null;
    }
  };

  render() {
    const { isSaving, data } = this.state;
    if (!data)
      return (
        <div />
      )

    if (!data.itensCampanhaMensagem.length) return null;

    return (
      <div>
        {campaignSteps.map(item => this.renderComponent(item))}
        {isSaving && <Loading small />}
      </div>
    );
  }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/screens/admin/MessagesCampaigns/Detail/Detail.js